import React, { useState } from 'react';
import qs from 'qs';

const queryParams = qs.parse(window.location.search.slice(1));

const getDefault = defaultView => {
    if (defaultView) return defaultView;
    if (queryParams.view) return queryParams.view;
    return 'list';
};

const useViewType = ({ defaultView }) => {
    const [viewType, setViewType] = useState(getDefault(defaultView));

    return { viewType, setViewType };
};

export default useViewType;
